<template>
	<div class="pay-record">
		<section class="fx filter-list">
			<div class="fx fx-wrap fx-fill">
				<!--<z-select v-if="shopList.length > 0" :options="shopList" v-model="params.shopId"  class="w150" @handleChange="handleOffset(0)"></z-select>-->
				<div>
					<z-select :options="statusItem" v-model="params.status" class="w150" @handleChange="handleOffset(0)"></z-select>
				</div>
				<div class="fx fx-wrap m-l-10">
					<!--<el-date-picker v-model="filterTime" type="daterange" align="left" placeholder="选择日期范围(默认所有)" :picker-options="pickerOptions" @change="initData">
					</el-date-picker>-->
					
					<el-date-picker
				      v-model="filterTime"
				      type="datetimerange"
				      :picker-options="pickerOptions"
				      placeholder="选择时间范围"
				      align="left"
				      >
				    </el-date-picker>
				</div>
			</div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="请输入订单号/门店名称..." @handleSearch="handleOffset(0)"></z-search></div>
		</section>
		<!--list-->
		<section>
			<z-table :offset="params.offset" :count="params.count" :total-count="this.payInfo.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in payInfo.list || []">
					<td>{{item.name||'-'}}</td>
					<td>{{item.order_no}}</td>
					<td>{{item.pay_money | filterMoney}}</td>
					<td>{{item.offer_money | filterMoney}}</td>
					<td>{{item.amount | filterMoney}}</td>
					<td :class="[item.status == 1?'success':item.status == 4?'ing':'fail']">{{item.status | payStatusFmt }}</td>
					<td>{{item.pay_type | filterOsType}}支付</td>
					<td>{{item.l_time| momentFmt}}</td>
					<td class="operating">
						<el-popover v-if="item.status==1 && item.pay_type != 'UnionPay'" placement="top" width="200" :ref="'refunds_'+index">
							<div class="z-popover">
								<div>退款金额将原路返回,确认要退款?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleRefunds(item)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-refund"></i><span>退款</span></a>
						</el-popover>
						<router-link  class="operat-btn" tag="a" :to="{ name: 'payRecordInfo', query:{id: item.id}}"><i class="icon-look"></i><span>订单详情</span></router-link>
					</td>
				</tr>
				<!--<tr slot="datasource" v-if="payInfo.list.length <= 0">
					<td colspan="20"><p class="p-20">暂无相关数据！</p></td>
				</tr>-->
				<!--<div slot="operate" v-show="payInfo.list && payInfo.list.length > 0">
					<a class="z-btn z-btn-primary b-r-3" @click="handleChoosePageNum()">导出订单数据</a>
				</div>-->
			</z-table>
		</section>
		<!--<z-popup :showModel="isPopExport">
			<div slot="popup-cont" class="popup-cont b-r-5">
				<p class="btn-close fx-align" @click="handleCloseExport"><i class="icon-close"></i></p>
				<div class="fx fx-y-center">
					<div class="title fx w80 m-r-5"><span class="fx-fill">选择页码(每页默认500条数据)：</span></div>
					<div class="fx-fill">
						<z-select :options="pageNum"class="w150" v-model="pageTarget"></z-select>
					</div>
				</div>
				<div><a class="btn-down" download="收银台报表.csv" @click="handleExportData">确定</a></div>
			</div>
		</z-popup>-->
	</div>

</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'PayRecord',
		components: {},
		data() {
			return {
				isDisableDown: false,//是否继续下载
				isPopExport: false,
				pageNum: [],
				pageTarget: '',
				columns: ['交易门店', '订单号', '实付金额(元)','优惠金额(元)','合计金额(元)', '订单状态', '付款方式', '时间', "操作"],
				params: {
					offset: 0, //分页偏移量
					count: 10, //每页多少条
					status: null, //支付状态
					startTime: null, //时间筛选
					endTime: null, //时间筛选
					search: null, //模糊搜索
					shopId: ''//门店id
				},
				filterTime:null,
				statusItem: [{
					value: null,
					text: '订单状态(全部)'
				}, {
					value: 1,
					text: '支付成功'
				}, {
					value: 4,
					text: '退款中'
				}, {
					value: 5,
					text: '退款成功'
				}],
				pickerOptions: {
		          shortcuts: [{
		            text: '最近一周',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近一个月',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近三个月',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
		              picker.$emit('pick', [start, end]);
		            }
		          }]
		        },
				shopList: []
			}
		},
		mounted() {
			this.initData();
//			this.handleGetShopList();
		},
		watch :{//监听数据变化
    		filterTime(val){
    			if(val) {
					this.params.startTime = this.filterTime[0];
					this.params.endTime = this.filterTime[1];
					this.initData();
				}
    		}
	  	},
		computed: {
			...mapState({
				payInfo: state => state.payRecord.payRecord
			})
		},
		filters: {
			payStatusFmt(payStatus) {
				switch(payStatus) {
					case 0:
						return '关闭';
						break;
					case 1:
						return '支付成功';
						break;
					case 2:
						return '待支付';
						break;
					case 3:
						return '已发货';
						break;
					case 4:
						return '退款中';
						break;
					case 5:
						return '退款成功';
						break;
				}
			}
		},
		/*
		 * 事件处理
		 */
		methods: {
//			handleExportData(e) {
//				if (!this.pageTarget) return this.$toast('请选择需要导出的页码');
//				
//				if (this.isDisableDown) return;
//				this.isDisableDown = true;
//				
//				let param = {
//					shopId: this.params.shopId,
//					status: this.params.status,
//					startTime: this.params.startTime,
//					endTime: this.params.endTime,
//					pageNum: this.pageTarget,
//					search: this.params.search,
//				};
//				this.exportCashierList(param).then((data) => {
//					e.target.href = data;
//					e.target.click();
//					this.isDisableDown = false;
//					this.isPopExport = false;
//					this.pageTarget = '';
//				}, (Error) => {
//					this.$log(Error);
//					this.$toast(Error);
//					this.isDisableDown = false;
//				})
//			},
			
//			handleChoosePageNum() {
//				this.isPopExport = true;
//				
//				let param = {
//					shopId: this.params.shopId,
//					status: this.params.status,
//					startTime: this.params.startTime,
//					endTime: this.params.endTime,
//					search: this.params.search,
//				};
//				
//				this.getCashierOrderCount(param).then((data) => {
//					this.pageNum = data;
//				}, (Error) => {
//					this.$log(Error);
//				})
//			},
			
//			handleCloseExport() {
//				this.isDisableDown = false;
//				this.isPopExport = false;
//				this.pageTarget = '';
//				this.pageNum = [];
//			},
			
			//初始化数据
			initData() {
				this.getPayRecordList(this.params)
			},
			
			//获取门店列表
//			handleGetShopList() {
//				this.getShopList().then((data) => {
////					this.$log('请求付款记录数据成功');
//					if (data.length > 0) {
////						this.shopList = data
//						this.shopList.push({value: "", text: '请选择门店'});
//						
//						data.map((item) => {
//							this.shopList.push({value: item.id, text: item.name});
//						});
//					}
//				}, (Error) => {
//					this.$log(Error);
//				});	
//			},
			
			//重新获取支付记录
			handleOffset(offset) {
				this.params.offset = offset;
				this.initData();
			},
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['refunds_' + index]) != "undefined") this.$refs['refunds_' + index][0].doClose();
			},
			//退款
			async handleRefunds(item = {}) {
				try{
					await this.sytRefunds({orderNo : item.order_no})
					item.status = 5
					this.$success('操作成功')
				}catch(e){
					this.$errorMsg(e)
				}
			},
			...mapActions(['getPayRecordList', 'sytRefunds', 'getCashierOrderCount', 'exportCashierList'])
		}
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.pay-record {
		background: $color-white;
		border: 1px solid $color-border;
		border-bottom: none;
		.filter-list {
			padding: px-em(40px);
		}
	}
	
		.popup-cont {
		width: 400px;
		background: #fff;
		transform-origin: 0 -20%;
		padding: 20px;
		.btn-close {
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i {
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active {
				i {
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
		.pic-cont {
			width: 360px;
			height: 512px;
			background: #fff url(../../../assets/img/code_mould.png) center center no-repeat;
			background-size: 100%;
			#qrcode {
				background: #fff;
				padding: 10px;
				width: 150px;
				height: 150px;
				position: absolute;
				top: 205px;
				left: 125px;
			}
		}
		.btn-down {
			width: 100%;
			background: $color-main;
			border-radius: 5px;
			display: block;
			color: #fff;
			font-weight: bold;
			font-size: 18px;
			text-align: center;
			padding: 10px 0;
			margin-top: 10px;
			transform: translate(0);
			&:active {
				opacity: 1;
				background: darken($color-main, 5%);
				transform: scale(0.95);
			}
		}
	}
	
	td {
		&.success {
			color: $color-success;
		}
		&.ing {
			color: $color-warning;
		}
		&.fail {
			color: $color-wrong;
		}
	}
	.operat-btn {
	    i,span {
			height: px-em(34px);
			line-height: px-em(34px);
	    }
    }
    @media only screen and (min-width:0px) and (max-width:640px) {
    	.filter-list{
    		display: none;
    	}
	}
</style>


// WEBPACK FOOTER //
// PayRecord.vue?24de35ba